export default "__VITE_ASSET__UNdJc_J9__"